// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-475aaa5c] .custom-radio .el-radio {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
